/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEvent, useCallback} from 'react';
import {BulkSettingFieldValues, GenericObject, SCIField} from '@ion/core/src/types/entities';
import RadioButton from '@ion/dls/src/components/radio/RadioButton';

export interface BulkSCISelectFieldProps {
  value: boolean | null | any;
  handleRadioChange: (e: MouseEvent<HTMLDivElement>, field: SCIField, selected: string) => void;
  field: SCIField | GenericObject;
  selected?: string;
}

/**
 * Select field for updating SCI setting for devices in bulk
 */
export const BulkSCISelectField = ({
  value,
  handleRadioChange,
  field,
  selected
}: BulkSCISelectFieldProps) => {
  const onChange = useCallback((field, key) => {
    return function(e) {
      handleRadioChange(e, field, selected);
    };
  }, [field, selected]);

  return (
    <>
      <RadioButton label
        checked={value === true}
        value={BulkSettingFieldValues.on}
        onChange={onChange(field, selected)}/>
      <RadioButton label
        checked={value === null}
        value={BulkSettingFieldValues.default}
        onChange={onChange(field, selected)}/>
      <RadioButton label
        checked={value === false}
        value={BulkSettingFieldValues.off}
        onChange={onChange(field, selected)}/>
    </>
  );
};

export default BulkSCISelectField;
